

import { useState } from "react"
import { ChevronDown } from "lucide-react"

import { Card, CardContent, CardHeader } from "@mui/material"



const coursesData: CourseContent[] = [
  {
    id: "course1",
    name: "البرنامج التدريبي الأولى",
    title: "استخدام الممارسة التأملية لإثراء التطوير الشخصي والمهني",
    description:
      "الممارسة التأملية هي أداة إدارة استراتيجية تدعم تطوير المعرفة والمهارات والسلوكيات في مكان العمل، من خلال تحليل الأداء الشخصي، وإيجاد الفرص والتحديات، وخبرات الأداء في سياقات مختلفة يمكن تحديد نوع التطوير المستمر",
    objectives: [
      "فهم مفهوم الممارسة التأملية وأهميتها",
      "تطبيق تقنيات التفكير النقدي في العمل",
      "تطوير مهارات التحليل الذاتي",
      "إنشاء خطط التطوير المهني الشخصية",
    ],
    sections: [
      {
        id: "concept",
        title: "مفهوم وفوائد الممارسة التأملية",
        content: [
          "التعريفات والمبادئ الرئيسية",
          "  النمو الشخصي والمهني",
          "تعزيز الوعي الذاتي والتعلم",
        ],
      },
      {
        id: "methods",
        title: "الأساليب والتطبيقات",
        content: [
          "اليوميات والسجلات",
          ,
          " مراجعات الأقران وجلسات التغذية الراجعة",
          "مجموعات التعلم العملي   ",
        ],
      },
      {
        id: "development",
        title: "إنشاء ثقافة تأملية  ",
        content: [
          "القيادة والدعم للممارسات التأملية",
          "دمج التأمل في مراجعات الأداء",
          "  تشجيع التواصل المفتوح والتعلم المستمر   ",
        ],
      },
    ],
  },
  {
    id: "course2",
    name: "البرنامج التدريبي الثانية",
    title: "استخدام البيانات والمعلومات لاتخاذ القرارات",
    description:
      "تؤدي القدرة على تحليل وإدارة البيانات والمعلومات إلى زيادة التنافسية والابتكار والإنتاجية ورضا العملاء. مع تزايد حجم البيانات والمعلومات بمعدلات غير مسبوقة، تصبح القدرة على تفسير واستخدام واستغلال 'البيانات الكبيرة' تحديًا تنظيمياً. تزود هذه الوحدة المتعلمين بفهم الغرض والممارسات المتعلقة بتفسير وإدارة وتقديم بيانات الأعمال والمعلومات لاتخاذ القرارات.",
    objectives: [
      "إدارة البيانات والمعلومات",
      "تحليل وتفسير البيانات",
      "تقديم البيانات والمعلومات",
    ],
    sections: [
      {
        id: "time-analysis",
        title: "إدارة البيانات والمعلومات",
        content: [
          "أهمية البيانات في اتخاذ القرارات",
          ,
          " طرق جمع البيانات (الاستطلاعات، المقابلات، قواعد البيانات)",
          "عمليات إدارة البيانات (التخزين، الاسترجاع، الأمان)",
        ],
      },
      {
        id: "planning-techniques",
        title: "تحليل وتفسير البيانات",
        content: [
          "الأساليب والأدوات الإحصائية (المتوسط، الوسيط، النمط، الانحراف المعياري)",
          "تقنيات تصور البيانات (الرسوم البيانية، الجداول، لوحات القيادة)",
          "ضمان جودة البيانات وسلامتها (الدقة، الاكتمال، الاتساق)",
        ],
      },
      {
        id: "productivity-tools",
        title: "تقديم البيانات والمعلومات",
        content: [
          "مبادئ العرض الفعال (الوضوح، الملاءمة، جذب الجمهور)",
          "طرق العرض (التقارير، العروض التقديمية، لوحات القيادة)",
          "تخصيص العروض التقديمية لأصحاب المصلحة المختلفين (الإداريين، أعضاء الفريق، العملاء)",
        ],
      },
    ],
  },
  {
    id: "course3",
    name: "البرنامج التدريبي الثالثة",
    title: "إدارة تجربة العملاء",
    description:
      "تقديم تجربة عملاء استثنائية يتطلب مهارة والتزام وفهم عميق لاحتياجات العملاء. تهدف هذه الوحدة إلى تطوير فهم المديرين لدورهم ومسؤولياتهم في إدارة تجربة العملاء. سيتعلم المتعلمون الميزات الرئيسية لثقافة خدمة العملاء ورحلة العميل التي إذا تمت إدارتها بفعالية، ستؤثر على نجاح المنظمة.",
    objectives: [
      "إتقان مهارات التواصل اللفظي وغير اللفظي",
      "تطوير تقنيات العرض والتقديم",
      "بناء الثقة في التحدث أمام الجمهور",
      "تعلم فنون الإقناع والتأثير",
    ],
    sections: [
      {
        id: "communication-basics",
        title: "إدارة تجربة العملاء",
        content: [
          "التعريفات والمفاهيم الرئيسية",
          "أهمية رضا العملاء وولائهم",
          "المكونات الرئيسية (جودة الخدمة، تفاعلات العملاء، تصور العلامة التجارية)",
        ],
      },
      {
        id: "presentation-skill",
        title: "تطوير ثقافة خدمة العملاء",
        content: [
          "التعريفات والمفاهيم الرئيسية",
          "أهمية رضا العملاء وولائهم",
          "المكونات الرئيسية (جودة الخدمة، تفاعلات العملاء، تصور العلامة التجارية)",
        ],
      },
      {
        id: "presentation-skills",
        title: "رسم خريطة رحلة العميل",
        content: [
          "مراحل رحلة العميل (الوعي، النظر، الشراء، الاحتفاظ، الترويج)",
          "تقنيات وأدوات رسم الخرائط",
          "تحديد وتحسين نقاط الاتصال",
        ],
      },
      {
        id: "confidence-building",
        title: "إدارة تغذية راجعة وشكاوى العملاء",
        content: [
          "أهمية التغذية الراجعة للتحسين المستمر",
          "طرق جمع التغذية الراجعة (الاستطلاعات، مجموعات التركيز، وسائل التواصل الاجتماعي)",
          "استراتيجيات فعالة لحل الشكاوى",
        ],
      },
    ],
  },
  {
    id: "course4",
    name: "البرنامج التدريبي الرابعة",
    title: "إدارة التغيير",
    description:
      "التغيير أمر لا مفر منه إذا أرادت المنظمة الحفاظ على التنافسية وتحديث الممارسات. تهدف هذه الوحدة إلى تمكين المتعلم من تقييم أنواع وأسباب التغيير داخل المنظمات والقدرة على اختيار وتطبيق النماذج النظرية لإدارته. الغرض ليس فقط تمكين المتعلمين من تطوير مهارات إدارة التغيير وتحقيق الأهداف المحددة، ولكن القيام بذلك بطريقة مهنية مع التواصل المفتوح والصادق طوال العملية.",
    objectives: [
      "فهم أنماط القيادة المختلفة",
      "تطوير مهارات إدارة الفرق",
      "تعلم تقنيات التحفيز والتأثير",
      "بناء ثقافة العمل الجماعي",
    ],
    sections: [
      {
        id: "leadership-styles",
        title: "أسباب وأنواع التغيير",
        content: [
          "العوامل الداخلية (الأهداف الاستراتيجية، إعادة هيكلة المنظمة، تحسين العمليات)",
          "العوامل الخارجية (اتجاهات السوق، التقدم التكنولوجي، التغييرات التنظيمية)",
          "أنواع التغيير (تحويلي، تدريجي، استراتيجي، تشغيلي)",
        ],
      },
      {
        id: "team-management",
        title: "النماذج النظرية لإدارة التغيير",
        content: [
          "نموذج إدارة التغيير ليوين",
          "نموذج التغيير ذو الخطوات الثمانية لكوتر",
          "نموذج ADKAR",
          "نموذج الانتقال لبرجز",
        ],
      },
      {
        id: "motivation-influence",
        title: "مبادئ إدارة التغيير",
        content: [
          "المبادئ الأساسية (التخطيط، التواصل، المشاركة، الدعم)",
          "دور القيادة والإدارة في التغيير",
          "استراتيجيات إدارة المقاومة (التعليم، المشاركة، التفاوض)",
        ],
      },
      {
        id: "motivation-influenc",
        title: "تنفيذ واستدامة التغيير",
        content: [
          "خطوات التنفيذ (التقييم، التخطيط، التنفيذ، المراجعة)",
          "مراقبة التقدم (مؤشرات الأداء الرئيسية، آليات التغذية الراجعة)",
          "ترسيخ التغيير (التدريب، التعزيز، تغيير الثقافة)",
        ],
      },
    ],
  },
  {
    id: "course5",
    name: "البرنامج التدريبي الخامسة",
    title: " مبادئ تقديم التدريب والإرشاد",
    description:
      "يعتبر التدريب والإرشاد تقنيات مثبتة لتعزيز المهارات والمعرفة والمواهب والإمكانيات للأفراد كجزء من استراتيجية التعلم والتطوير التنظيمي. تستكشف هذه الوحدة مبادئ وممارسات التدريب والإرشاد، وتأثير هذه التقنيات على تطوير ثقافة الأداء العالي.",
    objectives: [
      "إتقان منهجيات إدارة المشاريع",
      "تطوير مهارات التخطيط الاستراتيجي",
      "تعلم إدارة الموارد والميزانيات",
      "إتقان تقنيات المتابعة والتقييم",
    ],
    sections: [
      {
        id: "project-fundamentals",
        title: "مبادئ التدريب والإرشاد",
        content: [
          "التعريفات والمفاهيم الرئيسية",
          "الفروقات والتشابهات بين التدريب والإرشاد",
          "الفوائد للأفراد والمنظمات",
        ],
      },
      {
        id: "strategic-planning",
        title: "نماذج وتقنيات التدريب والإرشاد",
        content: [
          "نموذج GROW (الهدف، الواقع، الخيارات، الإرادة)",
          "نموذج CLEAR (التعاقد، الاستماع، الاستكشاف، العمل، المراجعة)",
          "نموذج OSKAR (النتيجة، التدرج، المعرفة، التأكيد والعمل، المراجعة)",
          "التقنيات (الاستماع الفعال، طرح الأسئلة، التغذية الراجعة)",
        ],
      },
      {
        id: "monitoring-evaluation",
        title: "المهارات والكفاءات",
        content: [
          "المهارات الأساسية (التواصل، التعاطف، الصبر، التفكير النقدي)",
          "طرق تطوير الكفاءات (التدريب، ورش العمل، التقييم الذاتي)",
          "تأثير التطوير الشخصي والمهني المستمر",
        ],
      },
      {
        id: "monitoring-evaluatio",
        title: "تنفيذ وإدارة البرامج",
        content: [
          "خطوات التنفيذ (تقييم الاحتياجات، التخطيط، التنفيذ، التقييم)",
          "طرق المراقبة والتقييم (الاستطلاعات، التغذية الراجعة، مؤشرات الأداء)",
          "استراتيجيات الاستدامة (دعم القيادة، التحسين المستمر، الدمج في الثقافة التنظيمية)",
        ],
      },
    ],
  },
  {
    id: "course6",
    name: "البرنامج التدريبي السادسة",
    title: "إدارة علاقات الأطراف المعنية",
    description:
      "العلاقات الجيدة، سواء كانت مع العملاء أو الموردين أو الشركاء أو الموظفين، تعتبر من العوامل الرئيسية لنجاح المنظمة. لبناء علاقات مع الأطراف المعنية تكون طويلة الأمد ومستدامة، يجب أن تكون مخططة ومتطورة. تستكشف هذه الوحدة أنواع وأغراض علاقات الأطراف المعنية والمهارات المطلوبة لتجاوز التحديات وإدارتها بفعالية.",
    objectives: [
      "فهم مكونات الذكاء العاطفي",
      "تطوير مهارات إدارة المشاعر",
      "تعلم تقنيات التعاطف والتفهم",
      "بناء علاقات مهنية قوية",
    ],
    sections: [
      {
        id: "emotional-awareness",
        title: "مبادئ إدارة الأطراف المعنية",
        content: [
          "التعريف وأنواع الأطراف المعنية (داخلية، خارجية، أولية، ثانوية)",
          "فوائد إدارة الأطراف المعنية (الثقة، التعاون، إدارة المخاطر)",
          "تأثيرها على الأداء التنظيمي (السمعة، الكفاءة، الابتكار)",
        ],
      },
      {
        id: "emotion-management",
        title: "إدارة المشاعر والضغوط",
        content: [
          "التعريف وأنواع الأطراف المعنية (داخلية، خارجية، أولية، ثانوية)",
          "فوائد إدارة الأطراف المعنية (الثقة، التعاون، إدارة المخاطر)",
          "تأثيرها على الأداء التنظيمي (السمعة، الكفاءة، الابتكار)",
        ],
      },
      {
        id: "relatonship-buiding",
        title: "تطوير والحفاظ على العلاقات",
        content: [
          "تحديد أولويات الأطراف المعنية (رسم خرائط الأطراف المعنية، التحليل)",
          "بناء العلاقات (الثقة، التواصل، المشاركة)",
          "دور التواصل (القنوات، الشفافية، التغذية الراجعة)",
        ],
      },
      {
        id: "relationship-buildig",
        title: "إدارة التوقعات والصراعات",
        content: [
          "فهم توقعات الأطراف المعنية (الاحتياجات، المصالح، القوة)",
          "تقنيات إدارة التوقعات (التفاوض، التوافق، التواصل)",
          "استراتيجيات حل النزاعات (الوساطة، التعاون، التسوية)",
        ],
      },
      {
        id: "relationship-buiding",
        title: "قياس الفعالية",
        content: [
          "معايير النجاح (الرضا، المشاركة، الولاء)",
          "جمع وتحليل التغذية الراجعة (الاستطلاعات، المقابلات، مجموعات التركيز)",
          "التحسين المستمر (خطط العمل، المراقبة، التقييم)",
        ],
      },
    ],
  },
  {
    id: "course7",
    name: "البرنامج التدريبي السابعة",
    title: "مبادئ الابتكار",
    description:
      "يمتلك الابتكار القدرة على تحويل المنظمات والفرق والأداء الفردي. عندما تزدهر ثقافة الابتكار وريادة الأعمال، تزدهر الأفكار والمبادرات الجديدة. تم تصميم هذه الوحدة لتمكين المتعلمين من تحديد فرص الابتكار في مكان العمل (والتي قد تكون على شكل ممارسات جديدة، عمليات، منتجات جديدة، أو خدمات)، تحليل مبررات تطوير المبادرات، ومعرفة كيفية تحويل الأفكار إلى واقع.",
    objectives: [
      "تطوير مهارات التفكير الإبداعي",
      "تعلم تقنيات العصف الذهني",
      "إتقان منهجيات حل المشكلات",
      "تطوير ثقافة الابتكار",
    ],
    sections: [
      {
        id: "creative-thinking",
        title: "مبادئ الابتكار",
        content: [
          "التعريفات والمفاهيم الرئيسية",
          "أنواع الابتكار (تدريجي، تحول، جذري)",
          "الفوائد والتحديات (الميزة التنافسية، المخاطر، مقاومة التغيير)",
        ],
      },
      {
        id: "brainstorming-techniques",
        title: "تعزيز ثقافة الابتكار",
        content: [
          "خصائص المنظمات المبتكرة (المرونة، الانفتاح، المخاطرة)",
          "استراتيجيات تعزيز الابتكار (الحوافز، التدريب، الموارد)",
          "دور القيادة (الرؤية، الدعم، القدوة)",
        ],
      },

      {
        id: "innovation-implementation",
        title: "إدارة الابتكار",
        content: [
          "العوامل الرئيسية للنجاح (الموارد، المهارات، البنية التحتية)",
          "التعاون والشبكات (الشراكات، الفرق متعددة الوظائف، الشبكات الخارجية)",
          "استدامة الابتكار (التحسين المستمر، المراقبة، التكيف)",
        ],
      },
    ],
  },
  {
    id: "course8",
    name: "البرنامج التدريبي الثامنة",
    title: "إدارة المالية",
    description:
      "مهارات إدارة المالية ضرورية لجميع المديرين بغض النظر عما إذا كان هناك فريق مالي مخصص داخل المنظمة. تعزز الفطنة المالية مهارات اتخاذ القرارات، والتي بدورها تدعم إدارة المشاريع والمهام والمجالات الوظيفية. تم تصميم هذه الوحدة لتمكين المتعلمين من فهم كيفية عمل النظم المالية داخل المنظمات، تقييم مصادر التمويل، وفهم المبادئ لوضع وإدارة الميزانيات بما يتماشى مع اللوائح والإرشادات التنظيمية.",
    objectives: [
      "إتقان استراتيجيات التفاوض",
      "تطوير مهارات الإقناع والتأثير",
      "تعلم قراءة لغة الجسد",
      "بناء اتفاقيات مربحة للجميع",
    ],
    sections: [
      {
        id: "negotiation-basics",
        title: "مبادئ إدارة المالية",
        content: [
          "المفاهيم الرئيسية (الربحية، السيولة، الملاءة، الكفاءة)",
          "الدور في دعم الأداء (تخصيص الموارد، قرارات الاستثمار، التحكم في التكاليف)",
          "التخطيط والسيطرة المالية (وضع الميزانيات، التقارير المالية، الامتثال)",
        ],
      },
      {
        id: "persuasion-techniques",
        title: "استخدام المعلومات المالية",
        content: [
          "أنواع المعلومات (قوائم الدخل، الميزانيات العمومية، بيانات التدفق النقدي)",
          "طرق التحليل (تحليل النسب، تحليل الاتجاهات، تحليل الفروقات)",
          "التأثير على القرارات (الاستثمار، التسعير، إدارة التكاليف)",
        ],
      },
      {
        id: "win-win-solutions",
        title: "وضع الميزانيات والتنبؤات",
        content: [
          "عملية وضع الميزانيات (الإعداد، الموافقة، المراقبة)",
          "أنواع الميزانيات (تشغيلية، رأسمالية، نقدية)",
          "دور التنبؤ (التنبؤ بالأداء المالي المستقبلي، التخطيط للطوارئ)",
        ],
      },
      {
        id: "win-n-solutions",
        title: "إدارة المخاطر المالية",
        content: [
          "أنواع المخاطر (مخاطر السوق، مخاطر الائتمان، مخاطر السيولة، المخاطر التشغيلية)",
          "طرق إدارة المخاطر (التحوط، التأمين، التنويع)",
          "خطة التخفيف من المخاطر (التحديد، التقييم، التدابير التحكمية)",
        ],
      },
    ],
  },
  {
    id: "course9",
    name: "البرنامج التدريبي التاسعة",
    title: "إجراء مشروع إدارة",
    description:
      "البحث في أساليب الإدارة والقيادة يمكن أن يؤدي إلى نتائج ديناميكية. الابتكار، تطوير المنتجات، تحسين الأداء، التغيير، التميز في خدمة العملاء، الاستراتيجية، وحل المشكلات هي بعض النتائج. بدون البحث، يمكن أن تتجمد الأعمال. تهدف هذه الوحدة إلى أن يقوم المتعلم بإجراء بحث إداري يكون له تأثير على الممارسة الفردية أو التنظيمية. من المتوقع أن يخطط المتعلمون ويديرون مشروعًا حقيقيًا في مكان العمل أو استفسارًا أكاديميًا يتعلق بحاجة أو تحدٍ تجاري محدد.",
    objectives: [
      "فهم ديناميكيات التغيير",
      "تطوير استراتيجيات إدارة التغيير",
      "بناء المرونة والتكيف",
      "قيادة عمليات التحول",
    ],
    sections: [
      {
        id: "change-dynamics",
        title: "اختيار المشروع والمنهجية",
        content: [
          "تحديد موضوعات البحث (الملاءمة، الجدوى، الاهتمام)",
          "مبررات الاختيار (الاحتياجات التجارية، التوافق الاستراتيجي، إمكانيات الابتكار)",
          "منهجيات البحث (نوعية، كمية، مختلطة)",
        ],
      },
      {
        id: "change-strategie",
        title: "تخطيط المشروع",
        content: [
          "تطوير خطط المشروع (الأهداف، الأغراض، النطاق، القيود)",
          "تحديد الموارد (البشرية، المالية، التكنولوجية)",
          "تحليل الأطراف المعنية (التحديد، الأدوار، استراتيجيات الاتصال)",
          "الجدول الزمني والمعالم (مخططات جانت، تحليل المسار الحرج)",
        ],
      },
      {
        id: "resilience-buildin",
        title: "إجراء البحث",
        content: [
          "طرق جمع البيانات (الاستطلاعات، المقابلات، الملاحظات، البيانات الثانوية)",
          "تقنيات تحليل البيانات (التحليل الإحصائي، التحليل الموضوعي، الترميز)",
          "ضمان الموثوقية والصلاحية (المثلثة، الدراسات التجريبية، مراجعة الأقران)",
        ],
      },
      {
        id: "resilience-uildin",
        title: "عرض النتائج",
        content: [
          "طرق العرض (التقارير، العروض التقديمية، الوسائل البصرية)",
          "كتابة التقارير (الهيكل، الوضوح، الاتساق)",
          "الاستنتاجات والتوصيات (الرؤى القابلة للتنفيذ، التأثيرات الاستراتيجية)",
          "تقييم الأثر (التنفيذ، التغذية الراجعة، التحسين المستمر)",
        ],
      },
    ],
  },
  {
    id: "course10",
    name: "البرنامج التدريبي العاشرة",
    title: "إدارة المساواة والتنوع والشمول",
    description:
      "المساواة والتنوع والشمول (EDI) أمور أساسية لخلق بيئة عمل يشعر فيها جميع الموظفين بالقيمة والاحترام. تهدف هذه الوحدة إلى تزويد المتعلمين بالمعرفة والمهارات اللازمة لتعزيز EDI داخل منظماتهم، وضمان الامتثال للتشريعات وخلق ثقافة شاملة.",
    objectives: [
      "وضع خطة التطوير المهني",
      "تحديد الأهداف المهنية طويلة المدى",
      "بناء الشبكات المهنية",
      "تطوير استراتيجيات التعلم المستمر",
    ],
    sections: [
      {
        id: "career-planningl",
        title: "مبادئ EDI",
        content: [
          "التعريفات والمفاهيم الرئيسية",
          "فوائد EDI (الابتكار، رضا الموظفين، الاحتفاظ بالمواهب)",
          "التأثير على الأداء والثقافة التنظيمية",
        ],
      },
      {
        id: "career-planningj",
        title: "تطوير وتنفيذ سياسات EDI",
        content: [
          "المكونات الرئيسية لسياسات EDI (الأهداف، النطاق، المسؤوليات)",
          "استراتيجيات التنفيذ (التدريب، الاتصال، آليات الدعم)",
          "دور القيادة (الالتزام، القدوة، المساءلة)",
        ],
      },
      {
        id: "continuous-klearning",
        title: "الأطر القانونية والأخلاقية",
        content: [
          "المتطلبات القانونية (قوانين مكافحة التمييز، لوائح تكافؤ الفرص)",
          "الاعتبارات الأخلاقية (الإنصاف، الاحترام، الشمولية)",
          "تأثير عدم الامتثال (العواقب القانونية، الضرر على السمعة)",
        ],
      },
      {
        id: "continuous-llearning",
        title: "إدارة ومراقبة مبادرات EDI",
        content: [
          "طرق إدارة المبادرات (خطط العمل، تخصيص الموارد، مشاركة الأطراف المعنية)",
          "تقنيات المراقبة (الاستطلاعات، التدقيق، مؤشرات الأداء)",
          "التحسين المستمر (آليات التغذية الراجعة، المراجعات المنتظمة، التعديلات)",
        ],
      },
    ],
  },
];

export default function CmiCourses() {
  const [activeDropdown, setActiveDropdown] = useState(null)
  const [activeCourse, setActiveCourse] = useState("course1")

  const toggleDropdown = (dropdown: string) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown)
  }

  const currentCourse = coursesData.find((course) => course.id === activeCourse) || coursesData[0]

  return (
    <div className=" cmi-courses" >
      <div className="container mx-auto">
        {/* Header Section */}
        <div className="text-center mb-8">

          <h2 className="services-header after:w-20 after:-bottom-2 text-center m-auto mb-4 mt-4">الدورات
          </h2>

          <p className="text-gray-600 max-w-4xl mx-auto leading-relaxed">
            يعتبر البرنامج سنة التميز، توزع فيها المراحل التخصص للبرنامج على ثمان ورش عمل منظومة متكاملة، تقبل مراحل
            تطوير قدرات القيادة التطبيقية والمهنية، وخبرات الأداء في سياقات مختلفة يمكن تحديد نوع التطوير المستمر
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar */}
          <div className="lg:w-80">
            <Card className="">
              <CardContent className="p-6">
                <div className="grid grid-cols-2 gap-3">
                  {coursesData.map((course) => (
                    <button
                      key={course.id}
                      onClick={() => {
                        setActiveCourse(course.id)
                        setActiveDropdown(null) // Reset dropdown when switching courses
                      }}
                      variant={activeCourse === course.id ? "default" : "outline"}
                      className={`h-12 text-sm font-medium transition-all duration-200 ${activeCourse === course.id
                          ? " hover:bg-red-6A2F38 text-white bg-[#6A2F38] rounded"
                          : "bg-gray-100 hover:bg-gray-200 text-gray-700 border-gray-300 rounded"
                        }`}
                    >
                      {course.name}
                    </button>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
          {/* Main Content */}
          <div className="flex-1">
            <Card className="">

              <CardContent className="p-8">
                <h5 className=" text-center text-[#D4AD89] mt-3 mb-3">{currentCourse.title}</h5>
                <p className="text-gray-700 leading-relaxed mb-8 text-center">{currentCourse.description}</p>

                {/* Course Objectives Button */}
                <div className="text-center mb-8">
                  <h3
                    onClick={() => toggleDropdown("objectives")}
                    className="  text-[#D4AD89] !text-start font-semibold"
                  >
                    أهداف البرنامج التدريبي
                  </h3>
                </div>

                {/* Objectives Dropdown */}
                {activeDropdown === "objectives" && (
                  <div className="mb-8 p-6 bg-orange-50 border border-orange-200 rounded-lg">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">أهداف البرنامج التدريبي:</h3>
                    <ul className="space-y-2">
                      {currentCourse.objectives.map((objective, index) => (
                        <li key={index} className="flex items-start gap-3">
                          <span className="w-2 h-2 bg-orange-400 rounded-full mt-2 flex-shrink-0"></span>
                          <span className="text-gray-700">{objective}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Course Sections */}
                <div className="row justify-content-center align-items-start">
                  {currentCourse.sections.map((section) => (
                    <div key={section.id} className="border border-gray-200 rounded-lg col-lg-5 p-0 m-2">
                      <button
                        onClick={() => toggleDropdown(section.id)}
                        className="w-full p-4 !text-start bg-gray-50 hover:bg-gray-100 transition-colors duration-200 flex items-center justify-between rounded-lg"
                      >
                        <span className="font-semibold text-gray-800">{section.title}</span>
                        <ChevronDown
                          className={`w-5 h-5 text-gray-600 transition-transform duration-200 ${activeDropdown === section.id ? "rotate-180" : ""
                            }`}
                        />
                      </button>
                      {activeDropdown === section.id && (
                        <div className="p-4 bg-white border-t">
                          <ul className="text-gray-700 leading-relaxed list-disc list-inside">
                            {section.content.map((item, index) => (
                              <li key={index} className="list-disc list-inside !text-start">{item}</li>
                            ))}
                          </ul>
                        </div>
                      )}

                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>


        </div>
      </div>
    </div>
  )
}
